import dayjs from 'dayjs';
import React, { useEffect, useMemo, useState } from 'react';
import { useLocation, useParams, useSearchParams } from 'react-router-dom';
import { logo } from '../../../configs/Icons';
import { useInit } from '../../Contexts/InitProvider';
import { useTemplate } from '../../features/template/TemplateProvider';
import PageTitle from '../../utils/PageTitle';
import PdfLayout from '../../utils/PdfLayout';
import ReportTable from './Components/ReportTable';
import { handleGetReportOpe } from './ReportsOperation';
import ReportsProvider from './ReportsProvider';

function Header() {
    const { initInfo } = useInit();
    return (
        <div className="flex justify-between items-center h-28">
            <div className="w-32">
                <img src={initInfo?.adminLogo || logo.mainLogoW} alt="logo" className="w-full" />
            </div>
            <div className=" overflow-auto text-left text-[10px] opacity-70">
                <p className="">
                    2521/34 Ladprao Road, Khlongchaokhunsing, <br /> Wangthonglang, Bangkok 10310,
                    Thailand
                </p>
                <div className="flex">
                    <p className="">
                        <b>Contact no:</b> +66 2514-0314-7, &nbsp;
                    </p>
                    <p className="">
                        <b>Email:</b> info@miracleadvance.com
                    </p>
                </div>
            </div>
        </div>
    );
}

function Footer() {
    return (
        <div className="w-full mt-20 pt-20 hidden print:block">
            <p className="text-xs text-primary-700 font-normal mb-5">
                Thank you for your cooperation and constant support during the project.
                <br /> Feel free to contact for more information or any kind of query.
            </p>

            <div className="flex items-center justify-end gap-x-2">
                <hr className="w-5 border-4 border-[#E74051]" />
                <p className="">
                    Integrate. <span className="text-[#E74051]">Accelerate.</span> Differentiate.
                </p>
            </div>
        </div>
    );
}

function PageCont() {
    const [reportData, setReportData] = useState({});
    const { category, type } = useParams();

    const { setMessage } = useTemplate();

    const { pathname } = useLocation();

    const reportType = pathname?.split('/').slice(-1)?.toString();

    // Search Params
    const [searchParams] = useSearchParams();
    const params = useMemo(
        () => ({
            dateStart: searchParams.get('start-date') || '',
            dateEnd: searchParams.get('end-date') || ''
        }),
        [searchParams]
    );

    useEffect(() => {
        handleGetReportOpe(category, type, params)
            .then(({ data }) => {
                setReportData(data);
            })
            .catch((err) => {
                setMessage({ type: 'error', text: err.toString(0) });
            });
    }, [setMessage, reportData, category, type, params]);

    return (
        <div className="w-[850px] print:w-[700px] rounded-[20px] shadow-[0px_0px_60px_0px_rgba(79,98,130,0.10)] print:shadow-none p-6 pt-0 print:p-0 mt-4 mb-24 print:my-0 mx-auto">
            <PdfLayout header={<Header />} footer={<Footer />}>
                <div className="w-full print:w-full mx-auto  print:ml-1 mt-2">
                    <div className="mb-4 flex items-start justify-between">
                        <div className="text-sm ">
                            <p>Date: </p>
                            <p className="font-medium">
                                {dayjs(params?.dateStart).format(`DD ${`MMMM`.slice(0, 3)} YYYY`)} -{' '}
                                {dayjs(params?.dateEnd).format(`DD ${`MMMM`.slice(0, 3)} YYYY`)}
                            </p>
                        </div>
                    </div>

                    <ReportTable reportType={reportType?.toLowerCase()} />
                </div>
            </PdfLayout>
        </div>
    );
}

function ReportInfoPage() {
    // set page title
    PageTitle(`Reports`);

    return (
        <ReportsProvider>
            <PageCont />
        </ReportsProvider>
    );
}

export default ReportInfoPage;
